import React, { useEffect, useState } from "react";
import Shearchbar from "./Shearchbar";
import Security from "./Security";
import Footer from "./Footer";
import Navbar from "./Navbar";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsFillCloudUploadFill } from "react-icons/bs";
import Manubar from "./Manubar";
import "react-tabs/style/react-tabs.css";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  AvatarGroup,
  IconButton,
  Stack,
  Divider,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardActions,
  CircularProgress,
} from "@mui/material";
import {
  Cancel,
  Person,
  Visibility,
  CalendarToday,
  Euro,
  ShoppingBag,
  ExitToApp,
  LocationOn,
  Receipt,
  Info,
  Add,
  Edit,
  Delete,
  Home,
  Article,
  PrivacyTip,
  Groups,
} from "@mui/icons-material";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const TransactionTable = () => {
  let Navigate = useNavigate();

  const location = useLocation();
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  let [orderlist, setOrderList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Pending");
  let [show_address, setshow_address] = useState([]);
  let [pincodemsg, setpincodemsg] = useState();
  const [activeTab, setActiveTab] = useState(location.state || "dashboard");
  const [dashboardData, setDashboardData] = useState([]);
  const [policy, setPolicy] = useState([]);
  const [terms_and_condition, setterms_and_condition] = useState([]);
  const [cancelDialog, setCancelDialog] = useState({
    open: false,
    orderId: null,
  });
  let [add_address, setadd_address] = useState({
    user_id: _id,
    landmark: "",
    address: "",
    city: "",
    pin_code: "",
  });
  const [about_us, setabout_us] = useState([]);
  let [newPinValue, setNewPinValue] = useState();
  let [oldPinvalue, setOldPinValue] = useState();
  const [showNewPin, setShowNewPin] = useState(false);
  const [showOldPin, setShowOldPin] = useState(false);

  // Add these new state variables at the top with your other states
  let [loading, setLoading] = useState(false);
  let [deleteLoading, setDeleteLoading] = useState(null);
  let [addLoading, setAddLoading] = useState(false);
  let [editLoading, setEditLoading] = useState(false);
  const [addressDialog, setAddressDialog] = useState({
    open: false,
    address: "",
  });
  const [transactionsData, setTransactionsData] = useState([]);

  const getTransactionStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "success";
      case "pending":
        return "warning";
      case "failed":
        return "error";
      default:
        return "default";
    }
  };

  const fetchTransactions = async () => {
    try {
      let data = {
        user_id: _id,
        order_status: selectedStatus,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/my_order_list`,
        data,
        { headers: { token } }
      );

      setTransactionsData(res.data.data || []);
    } catch (err) {
      console.log(err);
      setTransactionsData([]);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  return (
    <div>
      <Box sx={{ p: 3 }}>
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
            <Receipt sx={{ fontSize: 32, color: "primary.main" }} />
            <Typography variant="h4" component="h3" sx={{ fontWeight: 600 }}>
              Transaction History
            </Typography>
          </Stack>
        </Box>

        {/* Transactions Table */}
        <Paper
          elevation={2}
          sx={{
            width: "100%",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <TableContainer>
            <Table
              sx={{ minWidth: 650 }}
              aria-label="transaction history table"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.50" }}>
                  <TableCell sx={{ fontWeight: 600, py: 2 }}>
                    Transaction ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      py: 2,
                      textAlign: "center",
                    }}
                  >
                    Amount
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      py: 2,
                      textAlign: "center",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, py: 2 }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactionsData.map((item) => (
                  <TableRow
                    key={item.order_id}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                      "&:hover": {
                        backgroundColor: "action.hover",
                      },
                      transition: "background-color 0.2s",
                    }}
                  >
                    {/* Transaction ID */}
                    <TableCell sx={{ py: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          textAlign: "start",
                        }}
                      >
                        {item.order_no}
                      </Typography>
                    </TableCell>

                    {/* Amount */}
                    <TableCell sx={{ py: 2, textAlign: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: "success.main",
                        }}
                      >
                        ₹{item.grand_total}
                      </Typography>
                    </TableCell>

                    {/* Date */}
                    <TableCell sx={{ py: 2, textAlign: "center" }}>
                      <Typography variant="body2">{item.order_date}</Typography>
                    </TableCell>

                    {/* Status */}
                    <TableCell sx={{ py: 2 }}>
                      <Chip
                        label={item.order_status}
                        color={getTransactionStatusColor(item.order_status)}
                        size="small"
                        variant={
                          item.order_status === "Pending"
                            ? "outlined"
                            : "filled"
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Empty State (commented out for reference) */}
        {transactionsData.length === 0 && (
          <Box
            sx={{
              textAlign: "center",
              py: 8,
              color: "text.secondary",
            }}
          >
            <Receipt sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
            <Typography variant="h6" gutterBottom>
              No transactions yet
            </Typography>
            <Typography variant="body2">
              Your transaction history will appear here once you make a payment
            </Typography>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default TransactionTable;
